import { FunctionComponent } from "react"
import Sidebar from "../features/sidebar/components/sidebar"
import HeaderSection from "../components/header-section"
import FinishedModal from "../components/finished-modal"
import ThankYouComponent from "./thank-you"
import { useState } from "react"
const SimulationFinished: FunctionComponent = () => {
  const [finishedComponent, setFinishedComponent] = useState(false)

  const handleModalClose = () => {
    setFinishedComponent(true)
  }

  return (
    <div className="relative bg-base-white w-full h-[100%] overflow-hidden flex flex-row items-start justify-start">
      <Sidebar />
      <div className="flex-1 pb-8 bg-gray-50 h-[100dvh] flex flex-col items-center justify-start gap-[32px]">
        <HeaderSection hideBreadcrumbs hideHelpIcon hideProfileIcon />
        <div className="spacer w-full h-12"></div>

        {finishedComponent ? (
          <ThankYouComponent />
        ) : (
          <FinishedModal
            isSaving={false}
            saveError={null}
            onRetry={undefined}
            onClose={handleModalClose}
          />
        )}
      </div>
    </div>
  )
}

export default SimulationFinished
